const AddMemberIcon = ({ className }) => {
  return (
    <svg
      className={className}
      width="38"
      height="38"
      viewBox="0 0 38 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.3333 33.25V30.0833C25.3333 28.4036 24.666 26.7927 23.4783 25.605C22.2905 24.4173 20.6796 23.75 18.9999 23.75H7.91659C6.23688 23.75 4.62597 24.4173 3.43824 25.605C2.25051 26.7927 1.58325 28.4036 1.58325 30.0833V33.25"
        stroke="#E1CE7A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.4583 17.4167C16.9561 17.4167 19.7917 14.5811 19.7917 11.0833C19.7917 7.58553 16.9561 4.75 13.4583 4.75C9.96053 4.75 7.125 7.58553 7.125 11.0833C7.125 14.5811 9.96053 17.4167 13.4583 17.4167Z"
        stroke="#E1CE7A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.6667 12.6667V22.1667"
        stroke="#E1CE7A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M36.4167 17.4167H26.9167"
        stroke="#E1CE7A"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default AddMemberIcon
